import React from "react";
import PropTypes from "prop-types";
import { buildDividerStylesheet } from "./ElementDividerStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementDivider = (props) => {
  let element = props.element;
  const classes = style.classes(element, props.builder, props.device);
  const stylesheet = buildDividerStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  return (
    <React.Fragment>
      <div className={classes}>
        <hr className="cf-divider"></hr>
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:divider`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

const style = {
  classes: (element, builder, device) => {
    let options = element.options;
    let classes = "element-content cf-divider-outer ";

    let alignmentClass = "cf-outer-center";

    if (options["cf-alignment"]) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        alignmentClass = "cf-outer-left";
      } else if (options["cf-alignment"].indexOf("center") > -1) {
        alignmentClass = "cf-outer-center";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        alignmentClass = "cf-outer-right";
      }
    }

    classes += " " + alignmentClass;

    return classes;
  },
};

export default ElementDivider;
